import { type GetMissingDataFindingsQuery } from "~/gql/queries/missingDataFindings.generated";

export const missingDataEndpoints = {
	GetMissingDataFindings: {
		providesTags: [
			"AccountingIntegrationConfig",
			"Category",
			"Customer",
			"Items",
			"Location",
			"Price",
			"ProductionRecipe",
			"SiteLocation",
			"SpaceCapacityWindows",
			"Tenant",
			"Terms",
			"VendorMaterialCosts",
			"Me"
		] as AddTagTypes,
		transformResponse: (res: GetMissingDataFindingsQuery) => res
	}
};
